module.exports = __webpack_public_path__ + "static/media/service_Code.533b959e.png";